import { Image, View } from '@react-pdf/renderer';
import { emptyChart } from 'PDF/components/Charts/types';

interface ISalesFunnelImagePdfProps {
  imageSrc: string | 'emptyChart';
}

export const ChartImagePdf = ({ imageSrc }: ISalesFunnelImagePdfProps) => (
  <>
    {Boolean(imageSrc) && imageSrc !== emptyChart && (
      <View wrap={false} style={{ marginTop: 30 }}>
        <Image src={imageSrc} />
      </View>
    )}
  </>
);
